import { Injectable, signal } from '@angular/core';

// Deliberately BELOW the existing lg (1024px, main split grid in app.component.ts)
// and SIDEBAR_AUTO_COLLAPSE_PX (1280px) breakpoints — desktop/tablet windows in
// that range must never reach the new mobile-only code paths.
const MOBILE_MEDIA_QUERY = '(max-width: 767.98px)';
const COARSE_POINTER_MEDIA_QUERY = '(pointer: coarse)';

@Injectable({ providedIn: 'root' })
export class ViewportService {
  // Reactive — flips on resize/rotate. Drives which DOM subtree mounts
  // (sidebar drawer vs icon-rail, bottom-sheet chat, mobile control bar).
  isMobileLayout = signal<boolean>(this.computeIsMobile());

  // Computed once at boot, same pattern as AppComponent.obscuredEnforcementActive
  // (readonly, no recompute — a real device doesn't switch pointer type mid-session).
  // Drives interaction MODE (tap-to-show tooltips), not layout.
  readonly prefersCoarsePointer: boolean = (() => {
    try {
      return typeof window !== 'undefined' && window.matchMedia(COARSE_POINTER_MEDIA_QUERY).matches;
    } catch {
      return false;
    }
  })();

  constructor() {
    if (typeof window === 'undefined') return;
    try {
      const mql = window.matchMedia(MOBILE_MEDIA_QUERY);
      mql.addEventListener('change', (e) => this.isMobileLayout.set(e.matches));
    } catch {
      // matchMedia unavailable — stays at the initial computed value.
    }
  }

  private computeIsMobile(): boolean {
    if (typeof window === 'undefined') return false;
    try {
      return window.matchMedia(MOBILE_MEDIA_QUERY).matches;
    } catch {
      return false;
    }
  }
}
